var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.936533 16.9954C0.67486 16.9949 0.42541 16.8846 0.249043 16.6913C0.0694238 16.4995 -0.0198298 16.2402 0.00371059 15.9786L0.232252 13.4656L10.7899 2.91161L14.0893 6.21006L3.53444 16.7631L1.02142 16.9916C0.992502 16.9944 0.963585 16.9954 0.936533 16.9954ZM14.7479 5.55056L11.4494 2.2521L13.428 0.273584C13.6029 0.0984217 13.8403 0 14.0879 0C14.3355 0 14.5729 0.0984217 14.7479 0.273584L16.7264 2.2521C16.9016 2.42707 17 2.66449 17 2.91207C17 3.15965 16.9016 3.39708 16.7264 3.57204L14.7488 5.54963L14.7479 5.55056Z",
    fill: "url(#paint0_linear_0_713)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_713",
    x1: -4.02151,
    y1: 16.9954,
    x2: 37.5188,
    y2: 16.9954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3333FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2e49b329c5b0c849a22c65be4937261a.svg";
export { ForwardRef as ReactComponent };